module.exports = __webpack_public_path__ + "img/FR19506.b76b0438.svg";